// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.__feZSaBcISbbRU7m09G{display:flex;flex-direction:column;gap:3px}.hgQse9OFgGevdFbpUMgG{color:var(--content-primary-tertiary)}`, "",{"version":3,"sources":["webpack://./src/pages/settings/pages/emailToSms/ui/EmailToSmsHeader/styles.module.scss"],"names":[],"mappings":"AAAA,sBACE,YAAA,CACA,qBAAA,CACA,OAAA,CAEA,sBACE,qCAAA","sourcesContent":[".header {\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n\n  &Description {\n    color: var(--content-primary-tertiary);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": `__feZSaBcISbbRU7m09G`,
	"headerDescription": `hgQse9OFgGevdFbpUMgG`
};
export default ___CSS_LOADER_EXPORT___;
